import { render } from "./OutlineButton.vue?vue&type=template&id=e70bd3f4&scoped=true&ts=true"
import script from "./OutlineButton.vue?vue&type=script&lang=ts"
export * from "./OutlineButton.vue?vue&type=script&lang=ts"

import "./OutlineButton.vue?vue&type=style&index=0&id=e70bd3f4&scoped=true&lang=scss"

import exportComponent from "/opt/apps/parcel4you-web-staging/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e70bd3f4"]])

export default __exports__